<template>
  <div class="pt-2 secondary">
    <div class="text-h6 text-center mb-2">{{ groupName }} | {{ itemName }}</div>

    <v-btn small depressed color="primary" class="mb-8" @click="addButton"
      >Add Button</v-btn
    >

    <div
      class="d-flex align-center mb-2"
      v-for="(button, index) in buttons"
      :key="button.id"
    >
      <div class="body-2 mr-2">{{ index + 1 }}</div>

      <v-text-field
        dark
        dense
        hide-details
        outlined
        placeholder="Button Text"
        color="primary"
        class="flex-grow-0 mr-4"
      >
      </v-text-field>

      <v-select
        :items="actionTypes"
        item-text="value"
        item-value="key"
        label="Action Type"
        v-model="actionType"
        outlined
        dense
        dark
        color="primary"
        hide-details
        class="flex-grow-0 mr-4"
      ></v-select>

      <v-select
        item-text="value"
        item-value="key"
        label="Select Step"
        :items="steps"
        outlined
        dense
        dark
        color="primary"
        hide-details
        class="flex-grow-0"
      ></v-select>
    </div>
  </div>
</template>

<script>
import { nanoid } from "nanoid";

export default {
  props: ["groupName", "itemName"],
  data() {
    return {
      actionTypes: [
        {
          key: 1,
          value: "Start Step",
        },
        {
          key: 1,
          value: "Start Widget",
        },
      ],
      steps: [
        {
          key: 1,
          value: "Step 1",
        },
        {
          key: 2,
          value: "Step 2",
        },
      ],
      actionType: 1,
      buttons: [],
    };
  },
  methods: {
    addButton() {
      this.buttons.push({
        id: nanoid(),
        text: "",
        action: null,
      });
    },
    deleteButton(id) {
      this.buttons = this.buttons.filter((q) => q.id != id);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>